module.exports = __webpack_public_path__ + "fontawesome-webfont.32400f4e08932a94d8bf.eot";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/fontawesome-webfont.eot?v=4.5.0
// module id = ../../../../../resources/layout/fonts/fontawesome-webfont.eot?v=4.5.0
// module chunks = styles